export const SynchronousElasticSearchDicomJsonSyncEvent = {
	'Synchronous-ElasticSearchDicomJsonSyncEvent': true
};